"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .factory("Attachment", [
    "$resource",
    "$stateParams",
    "apiSettings",
    function ($resource, $stateParams, apiSettings) {
      return $resource(
        apiSettings.baseUri + "v1/attachments/:id",
        { id: "@id" },
        {
          list: {
            method: "GET",
            isArray: true,
            params: {
              promotionRequestId: 0,
            },
          },
          listIds: {
            url: apiSettings.baseUri + "v1/attachments/list/ids",
            method: "GET",
            isArray: true,
          },
          salesApproval: {
            url: apiSettings.baseUri + "v1/attachments/:id/sales-approval",
            method: "PUT"
          },
          insert: {
            method: "POST",
          },
          update: {
            method: "PUT",
          },
          delete: {
            method: "DELETE",
            params: {
              id: 0,
            },
          },
        }
      );
    },
  ]);
